"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _ui = require("@alycecom/ui");

var _yup = require("@hookform/resolvers/yup");

var _material = require("@mui/material");

var _react = _interopRequireWildcard(require("react"));

var _reactHookForm = require("react-hook-form");

var _chiliPiperIntegration = require("../constants/chiliPiperIntegration.schema");

var ChiliPiperIntegration = function ChiliPiperIntegration(_ref) {
  var _errors$bookingLink;

  var onSubmit = _ref.onSubmit,
      _ref$isSubmitEnabled = _ref.isSubmitEnabled,
      isSubmitEnabled = _ref$isSubmitEnabled === void 0 ? true : _ref$isSubmitEnabled,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      defaultValues = _ref.defaultValues;

  var _useForm = (0, _reactHookForm.useForm)({
    defaultValues: defaultValues || _chiliPiperIntegration.chiliPiperBookingFormSchema.getDefault(),
    resolver: (0, _yup.yupResolver)(_chiliPiperIntegration.chiliPiperBookingFormSchema)
  }),
      setValue = _useForm.setValue,
      handleSubmit = _useForm.handleSubmit,
      register = _useForm.register,
      errors = _useForm.formState.errors;

  (0, _react.useEffect)(function () {
    var _defaultValues$bookin;

    setValue('bookingLink', (_defaultValues$bookin = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.bookingLink) !== null && _defaultValues$bookin !== void 0 ? _defaultValues$bookin : '', {
      shouldValidate: false
    });
  }, [defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.bookingLink, setValue]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    spacing: 2,
    onSubmit: handleSubmit(onSubmit),
    component: "form"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    xs: 12,
    md: 6,
    xl: 5,
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({}, register('bookingLink'), {
    variant: "outlined",
    fullWidth: true,
    disabled: !isSubmitEnabled || isLoading,
    error: !!(errors !== null && errors !== void 0 && errors.bookingLink),
    helperText: errors === null || errors === void 0 ? void 0 : (_errors$bookingLink = errors.bookingLink) === null || _errors$bookingLink === void 0 ? void 0 : _errors$bookingLink.message
  }))), isSubmitEnabled && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    xs: 12,
    item: true
  }, /*#__PURE__*/_react.default.createElement(_ui.Button, {
    type: "submit",
    variant: "outlined",
    disabled: isLoading
  }, "Connect Chili Piper Integration")));
};

var _default = ChiliPiperIntegration;
exports.default = _default;